import { anims } from '../engine/anims-sidecar'
import { IMachine } from './machines'
import { machines } from './machines-sidecar'
import { machinesAnims } from './machinesAnims-sidecar'
import { common } from '../main/common-sidecar'
import { monsters } from '../monsters/monsters-sidecar'

function ensure(obj: IMachine) {
  machines.ensureType(obj, 'door')
}

export function onCreate(obj: IMachine) {
  ensure(obj)
  obj.onUpdate = onUpdate
  open(obj, false)
}

export function onUpdate(obj: IMachine) {
  ensure(obj)

  // Auto-close
  if (obj.isOpen) {
    if (!isInTransition(obj)) {
      obj.progress += common.getUpdateDeltaScaled()
      if (obj.progress > 2) {
        if (monsters.findAtSpot(obj.i, obj.j)) {
          obj.progress = 0
        } else {
          open(obj, false)
        }
      }
    }
  }

  anims.update(obj.parts[0].anim)
  anims.update(obj.parts[1].anim)
}

export function isInTransition(obj: IMachine) {
  ensure(obj)
  return obj.parts[0].anim.playing
}

export function open(obj: IMachine, isOpen: boolean) {
  ensure(obj)
  if (obj.isOpen !== isOpen) {
    obj.isOpen = isOpen
    obj.progress = 0
    if (isOpen) {
      anims.play(obj.parts[0].anim, machinesAnims.all.doorTopOpen)
      anims.play(obj.parts[1].anim, machinesAnims.all.doorBottomOpen)
    } else {
      anims.play(obj.parts[0].anim, machinesAnims.all.doorTopClose)
      anims.play(obj.parts[1].anim, machinesAnims.all.doorBottomClose)
    }
  }

  // spriteMap obj.parts[0].image
}
